import {
  isCarvanaNativeApp,
  isAndroidNativeWebview as isAndroidNativeWebviewFn
} from '../is-native-app';
import { MobileWebviewEvents } from '../mobile-webview-events';
import sendNativeEvent from '../send-native-event';
import type { NativeEventSource } from '../send-native-event';

// Check for native message handler OR user agent detection
export const isNativeWebview = !!(window.nativeWebViewMessageHandler ?? isCarvanaNativeApp());

export const isAndroidNativeWebview = isNativeWebview && isAndroidNativeWebviewFn();

export const enterNativeFullscreen = (source: NativeEventSource) => {
  if (isNativeWebview) {
    sendNativeEvent({
      event: MobileWebviewEvents.ENTER_FULLSCREEN,
      payload: {},
      source
    });
  }
};

export const leaveNativeFullscreen = (source: NativeEventSource) => {
  if (isNativeWebview) {
    sendNativeEvent({
      event: MobileWebviewEvents.LEAVE_FULLSCREEN,
      payload: {},
      source
    });
  }
};
